import { Component, Input, OnChanges, OnInit, SimpleChanges, Output } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { UieventhubService } from '@src/app/helpers/uieventhub/uieventhub.service';
import { Subscription } from 'rxjs';
import { Project } from '@src/app/models/project';
import { Task } from '@src/app/models/task';
import { DatastoreService } from '@src/app/helpers/datastore/datastore.service';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-projectoverview',
  templateUrl: './projectoverview.component.html',
  styleUrls: ['./projectoverview.component.css']
})
export class ProjectoverviewComponent implements OnInit {
  showfilter:boolean;
  ontrack:boolean;
  almost:boolean;
  notontrack:boolean;
  projectList:Project[];
  projOntrack:number;
  projAlmost:number;
  projNotontrack:number;
  projOntrackProc:number;
  projAlmostProc:number;
  projNotontrackProc:number;
  totalProjects:number;
  @Input() tasksDue:Task[];
  @Input() tasksOverdue:Task[];
  @Input() tasksUpcoming:Task[];
  @Input() tasksDone:Task[];
  @Input() allTasks:Task[];
  @Output() userview:boolean;
  filetoggle: boolean = false;
  projectFilterAppliedSubscription:Subscription;
  projectlistSubscription:Subscription;
  filterApplied:boolean;
  @Output() fromtemplate:boolean;

  constructor(
    private uieventhub: UieventhubService,
    private datastore: DatastoreService,
    ) {
    this.projectFilterAppliedSubscription = this.uieventhub.tagFilterApplied$.pipe(untilDestroyed(this)).subscribe(applied => {
      if(applied.some(a => a.tagtype == "project")){
        this.filterApplied = true;
      }else{
        this.filterApplied = false;
      }
     
    });
    this.projectlistSubscription = this.datastore.projectList$.pipe(untilDestroyed(this)).subscribe(list => {
      this.projectList = list;
      this.getOverduedays(this.projectList ? this.projectList : []);
    });

    //subscribe to task list
    this.datastore.taskList$.pipe(untilDestroyed(this)).subscribe(tasks => {
      this.tasksDue = [];
      this.tasksOverdue = [];
      this.tasksUpcoming = [];
      this.tasksDone = [];
      //filter my tasks only
      this.allTasks = tasks.filter(t => t.responsible == SessionHelper.getUserSub());
      if(this.allTasks){
        this.allTasks.forEach(t => {
          //if the task is done and has a valid from date within the last 30 days 
          if(t.taskstate == 'Done' && t.validfrom > new Date(new Date().setDate(new Date().getDate() - 30)).toISOString() ){
            this.tasksDone.push(t);
          }else if(t.taskstate != 'Done'){
            if(t.duedate.substring(0,10) < new Date().toISOString().substring(0,10)){
              this.tasksOverdue.push(t);
              //else if the task is due today
            }else if(t.duedate.substring(0,10) == new Date().toISOString().substring(0,10)){
              this.tasksDue.push(t);
            }else {
              this.tasksUpcoming.push(t);
            }
          }
        });
      }
    });

  }

 

  ngOnInit() {
    this.tasksDue = [];
    this.tasksOverdue = [];
    this.tasksUpcoming = [];
    this.tasksDone = [];
    this.showfilter = false;
    this.ontrack = false;
    this.almost = false;
    this.notontrack = false;
    this.userview = SessionHelper.getUserview()=="true" ? true : false;
    this.projectList=[];
    this.projectList = this.datastore.projectList.getValue();//JSON.parse(SessionHelper.getPortalProjectList());
    this.projAlmost = 0;
    this.projNotontrack = 0;
    this.projOntrack = 0;
    this.getOverduedays(this.projectList ? this.projectList : []);
    // this.projAlmost = 0;
    // this.projNotontrack = 0;
    // this.projOntrack = 0;
    // //console.log('list from overview',this.projectList);
    // for (var i = 0; i < this.projectList.length; i++) {
    //   if (this.projectList[i].overduedays == 0){
    //     this.projOntrack++;
    //    ////console.log('We are in track',this.projOntrack)
    //   }
    //   if (this.projectList[i].overduedays > 0 && this.projectList[i].overduedays < 3){
    //     this.projAlmost++;
    //   }
    //   if (this.projectList[i].overduedays > 3){
    //     this.projNotontrack++;
    //   }
    //        //console.log('Overduedays ProjectList',this.projectList[i].overduedays);

    // }
  }
  getOverduedays(projList:Project[]) {
    //this.totalProjects = projList.length;
    //console.log('Total Projs',this.totalProjects)
          this.projAlmost = 0;
      this.projNotontrack = 0;
      this.projOntrack = 0;
    for (var i = 0; i < projList.length; i++) {
      if (projList[i].overduedays == 0 && projList[i].isactive == true){
        this.projOntrack++;
        //this.projOntrackProc = (this.projOntrack / this.totalProjects) *100;
          //console.log('We are in track',this.projOntrack)
      }
      if (projList[i].overduedays > 0 && projList[i].overduedays < 3 && projList[i].isactive == true){
        this.projAlmost++;
        //this.projAlmostProc = (this.projAlmost / this.totalProjects) *100;
          //console.log('We are almost track',this.projAlmost)
      }
      if (projList[i].overduedays >= 3 && projList[i].isactive == true){
        this.projNotontrack++;
       // this.projNotontrackProc = (this.projNotontrack / this.totalProjects) *100;
       //console.log('We are not track',this.projNotontrack)
      }
    }
  }

  showfilterToggle(){
    this.showfilter = !this.showfilter;

    this.uieventhub.setShowProjectListFilter(this.showfilter);
    if(this.showfilter){
      this.ontrack = false;
      this.almost = false;
      this.notontrack = false;
    } 

  }

  userviewToggle(){
    this.userview = !this.userview;
    SessionHelper.setUserview(this.userview.toString());
    this.uieventhub.setPortalView(this.userview  ? "user":"project");
  }

  filelistToggle(){
    this.filetoggle = !this.filetoggle;
  }

  ontracktoggle(){
    this.ontrack = !this.ontrack;
    if(this.ontrack){
      this.almost = false;
      this.notontrack = false;
      this.uieventhub.setProjectsFilterType('ontrack');
    }else{
      this.uieventhub.setProjectsFilterType('');
    }
    
  }

  almosttoggle(){
    this.almost = !this.almost;
    if(this.almost){
      this.ontrack = false;
      this.notontrack = false;
      this.uieventhub.setProjectsFilterType('almost');
    }else{
      this.uieventhub.setProjectsFilterType('');
    }
  }

  notontracktoggle(){
    this.notontrack = !this.notontrack;
    if(this.notontrack){
      this.ontrack = false;
      this.almost = false;
      this.uieventhub.setProjectsFilterType('notontrack');
    }else{
      this.uieventhub.setProjectsFilterType('');
    }
  }
}


